import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import styles from "./styles/OTP.module.css"
import { useLocation, useNavigate } from "react-router-dom";
import config from '../../config.js';
import { decryptText } from "../../Utils/OstreonEncryption";
import { formatEmail } from "../../Utils/formatEmail";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import parse from "html-react-parser";

const base_url=config.base_url
export function BeneficiaryOTP(){
    const navigate = useNavigate()
    const [OTP, setOTP]=useState('')
    const location = useLocation()
    const [loginDisabled, setLoginDisabled] = useState(false)
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );

    const [content, setContent] = useState(
        websiteCurrentLang.content.BeneficiaryLoginOTP
    );
    useEffect(() => {
        setContent(websiteCurrentLang.content.BeneficiaryLoginOTP);
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    
    const [tooLong, setTooLong] = useState(false);

    const timeoutDuration = 120000;

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setTooLong(true);
        }, timeoutDuration);

        return () => clearTimeout(timeoutId);
    }, []);
    
    const [loginError, setLoginError]=useState(null)
    const beneficiary_key = window.sessionStorage.getItem('ostreon_beneficiary_key')
    if (!beneficiary_key) navigate('/beneficiary/login')
    useEffect(() => {
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu"
        document.body.appendChild(script)
      }, [])
    const showError = (error)=>{
        setLoginError(error)
        setLoginDisabled(false)
        setTimeout(()=>{
            setLoginError(null)
        }, 3000);
    }
    const handleLogin = async(token)=>{
        
        let credentials = {}
        credentials.otp=OTP
        fetch(base_url+'beneficiary/login/OTP', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            body: `OTP=${OTP}&token=${token}`,
            credentials:'include'
        }).then((res)=>{
            return res
        }).then(async (res)=>{
            if (res.status===301) {
                window.sessionStorage.setItem('ostreon_beneficiary_terms', true)
                navigate('/beneficiary/terms')
            }
            else if (res.status===429) return setLoginError(content.BeneficiaryLoginOTPError1);
            else if (res.status!==200) return setLoginError(content.BeneficiaryLoginOTPError2);
            
            else{
                try{
                    const response = await res.json()
                    const encrypted_key=response.encrypted_key
                    const ostreon_key = await decryptText(beneficiary_key, encrypted_key)
                    window.sessionStorage.setItem('ostreon_key', ostreon_key)
                    navigate('/beneficiary/home', {replace:true});

                }catch(e){
                    console.log(e)
                    navigate('/beneficiary/login', {replace:true});
                }
                
            }
        }).catch((err)=>{
            console.log(err)
            showError(err)
        }).finally(()=>{
            setLoginDisabled(false)
        })
    }
    const submitCaptcha = (e)=>{
        e.preventDefault()
        window.grecaptcha.ready(() => {
            setLoginDisabled(true)
            window.grecaptcha.execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
            .then(token => {
                if (!OTP) return showError(dublicatedcontent.dublicatedText52);
                handleLogin(token)
            }).catch(()=>setLoginDisabled(false));
            });
    }
    const handleEnter = (e) =>{
        if (e.key==="Enter"){
            submitCaptcha(e)
        }
    }
    return(   
        <div className={styles.main_div}>
            <div className={styles.title}>{dublicatedcontent?.beneficiary_login}</div>
            <div className={styles.sub_title}>
            {parse(content.BeneficiaryLoginOTPText1)}
            </div>
            <div className={styles.main_box}>
                <div className={styles.head}>
                    {location?.state?.username&&<div className={styles.top}>
                        {dublicatedcontent?.logged_in_as} {formatEmail(location.state.username)}
                    </div>}
                    <div className={styles.bottom}>
                        {dublicatedcontent?.not_you} <span className={styles.top_link} onClick={()=>navigate('/beneficiary/login')}>{dublicatedcontent?.dublicatedText53}</span>
                    </div>
                </div>
                <div className={styles.top}>
                    <div className={styles.input_text}>{dublicatedcontent
                    ?.dublicatedText54}</div>
                    {tooLong ? (
                        <div className={styles.too_long}>
                            <div className={styles.red_text}>{dublicatedcontent.dublicatedText55}</div>
                            <span className={styles.login_link} onClick={()=>navigate('/login')}>{dublicatedcontent.dublicatedText56}</span>
                        </div>
                    ) : (
                        <input autoFocus onKeyDown={handleEnter} className={`${styles.input} ${loginError ? styles.field_error : ''}`} value={OTP} onChange={(e)=>{setOTP(e.target.value)}} placeholder={dublicatedcontent.dublicatedText57}></input>
                    )}
                    {loginError?<div className={styles.login_error}>{loginError}</div>:null}
                    <button disabled={loginDisabled} onClick={(e)=>submitCaptcha(e)} className={styles.login_button}>{dublicatedcontent.dublicatedText3}</button>
                </div>
            </div>
        </div>
    )   
}